import { useEffect, useState } from "react";
import YesNoToggle from "./YesNoToggle";
import { getCitiesByCountry, getAllCategories } from "../../services/eventService";

export default function EventTypeSection({
  digitalEvent,
  setDigitalEvent,
  featureEvent,
  setFeatureEvent,
  eventNature,
  setEventNature,
  setSelectedCategoryId,
}) {
  const [categories, setCategories] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedParent, setSelectedParent] = useState(null);
  const [selectedChild, setSelectedChild] = useState(null);
  const [selectedSubChild, setSelectedSubChild] = useState(null);

 /* =========================
    FETCH CITIES
 ========================== */
 useEffect(() => {
   getCitiesByCountry(1)
     .then((res) => setCities(res.data))
     .catch((err) => console.error("City fetch error:", err));
 }, []);

 /* =========================
    FETCH CATEGORIES
 ========================== */
 useEffect(() => {
   getAllCategories()
     .then((res) => setCategories(res.data))
     .catch((err) => console.error("Category fetch error:", err));
 }, []);
  /* =========================
     FINAL CATEGORY ID
  ========================== */
  useEffect(() => {
    const finalId =
      selectedSubChild?.id ||
      selectedChild?.id ||
      selectedParent?.id ||
      null;

    if (setSelectedCategoryId) {
      setSelectedCategoryId(finalId);
    }
  }, [selectedParent, selectedChild, selectedSubChild]);

  return (
    <div className="mb-10 px-4 sm:px-0">
      <h4 className="text-xl font-medium mb-8">Event Type</h4>

      {/* Toggles */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-10">

        <YesNoToggle
          label="Digital Event"
          value={digitalEvent}
          onChange={() => setDigitalEvent(!digitalEvent)}
        />

        <YesNoToggle
          label="Feature Event"
          value={featureEvent}
          onChange={() => setFeatureEvent(!featureEvent)}
        />

        <YesNoToggle
          label="Multiple Venues"
          value={eventNature === "MULTI_VENUE"}
          onChange={() =>
            setEventNature(
              eventNature === "MULTI_VENUE"
                ? "SINGLE_LOCATION"
                : "MULTI_VENUE"
            )
          }
        />

      </div>

      <div className="border-t border-neutral-400 mb-8"></div>

      {/* Select Fields */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* ✅ City Dropdown from API */}
        <select
          name="cityId"
          className="input-style w-full"
          required
        >
          <option value="">Select City</option>
          {cities.map((city) => (
            <option key={city.id} value={city.id}>
              {city.cityName}
            </option>
          ))}
        </select>

        {/* Parent Category */}
        <select
          className="input-style w-full"
          onChange={(e) => {
            const selected = categories.find(
              (cat) => cat.id === Number(e.target.value)
            );
            setSelectedParent(selected);
            setSelectedChild(null);
            setSelectedSubChild(null);
          }}
          required
        >
          <option value="">Select Category</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.eventCategoryName}
            </option>
          ))}
        </select>

        {/* Child Category */}
        {selectedParent?.children?.length > 0 && (
          <select
            className="input-style w-full"
            onChange={(e) => {
              const selected = selectedParent.children.find(
                (cat) => cat.id === Number(e.target.value)
              );
              setSelectedChild(selected);
              setSelectedSubChild(null);
            }}
          >
            <option value="">Select Sub Category</option>
            {selectedParent.children.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.eventCategoryName}
              </option>
            ))}
          </select>
        )}

        {/* Sub Child Category */}
        {selectedChild?.children?.length > 0 && (
          <select
            className="input-style w-full"
            onChange={(e) => {
              const selected = selectedChild.children.find(
                (cat) => cat.id === Number(e.target.value)
              );
              setSelectedSubChild(selected);
            }}
          >
            <option value="">Select Sub Sub Category</option>
            {selectedChild.children.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.eventCategoryName}
              </option>
            ))}
          </select>
        )}

      </div>
    </div>
  );
}